import emailjs from '@emailjs/browser';
import config from "../config/config";

// EmailJS configuration is now in config.ts
export interface QuoteFormData {
    name: string;
    email: string;
    phone: string;
    service: string;
    subservice: string;
    product?: string;
    message: string;
    company?: string;
    urgency?: 'urgent' | 'normal' | 'planned';
}

export const sendQuoteRequestEmail = async (formData: QuoteFormData): Promise<boolean> => {
    try {

        // Initialize EmailJS with the public key
        emailjs.init(config.emailjs.publicKey);

        const templateParams = {
            name: formData.email.split('@')[0], // Or set a generic name
            clientName: formData.name,
            clientEmail: formData.email || 'notfound@gmail.com',
            clientPhone: formData.phone || 'Non fourni',
            clientCompany: formData.company || 'Non fourni',
            clientUrgency: formData.urgency || 'Normal',
            serviceName: formData.service,
            subServiceName: formData.subservice || '',
            productName: formData.product || '',
            clientMessage: formData.message,
            submittedAt: new Date().toLocaleString('fr-FR'),
            emailTo: config.contact.email
        };
        await emailjs.send(
            config.emailjs.serviceID,
            config.emailjs.templateID,
            templateParams
        );

        console.log('quote email sent successfully!');

        return true;
    } catch (error) {
        console.error('Failed to send email:', error);
        return false;
    }
};
